import { useForm } from '@brenger/react';
import { useMutation } from '@tanstack/react-query';
import { push } from 'connected-react-router';
import * as React from 'react';
import { Translate } from 'react-localize-redux-dep-updated';
import { useDispatch } from 'react-redux';
import '../../../assets/user/user.scss';
import { Button, Col, FlashMessage, Heading, InputPassword, Row, SectionWrapper } from '../../../brenger-shared-ui';
import { r } from '../../../routes';
import { translate } from '../../../utils/localization';
import { coreClient } from '../../../utils/request';
import { runValidators } from '../../../utils/validation';
import { PersonSchema } from '../schema';
import { RouteComponentProps } from 'react-router';

export const PasswordNewPage: React.FC = (props: RouteComponentProps<{ token: string }>) => {
  const dispatch = useDispatch();
  const passwordNew = useMutation({
    mutationFn: coreClient.users.resetPassword,
    onSuccess: () => {
      form.reset();
    },
  });

  const form = useForm({
    initialState: {
      password: '',
    },
    validators: {
      password: val => runValidators(val, PersonSchema.new_password),
    },
  });

  const onSubmit = (e: React.FormEvent): void => {
    e.preventDefault();
    if (form.hasErrors || passwordNew.isPending) {
      return;
    }
    passwordNew.mutate({
      token: props.match.params.token,
      password: form.data.password.value,
    });
  };

  return (
    <SectionWrapper extraClasses={'login-wrapper'} sectionStyle={'white'} centerContent={true}>
      <form onSubmit={onSubmit} noValidate>
        <Heading size={2}>
          <Translate id={'authentication.new.headline'} />
        </Heading>
        <Row>
          <Col xs={12} extraClasses={'pt-[1em]'}>
            <InputPassword
              autoComplete="new-password"
              name="user.password"
              placeholder={translate('form.fields.user.new_password.label')}
              value={form.data.password.value}
              onChange={password => form.set({ password })}
              meta={{
                error: form.getError('password'),
                showError: form.data.password.isDirty,
              }}
            />
          </Col>
          {passwordNew.error && (
            <Col xs={12} sm={12} extraClasses={'login-errors'}>
              <FlashMessage type={'error'} message={passwordNew.error.message} />
            </Col>
          )}
          {passwordNew.isSuccess && (
            <Col xs={12} sm={12} extraClasses={'login-success'}>
              <div className="pt-[1em]">
                <FlashMessage type={'success'} message={String(translate('authentication.new.success'))} />
              </div>
              <div className={'proceed-to-login'}>
                <Translate
                  id={'authentication.new.login_as'}
                  data={{
                    customer: (
                      <a
                        href="#"
                        onClick={e => {
                          e.preventDefault();
                          dispatch(push(r.user.login()));
                        }}
                      >
                        <Translate id={'authentication.new.customer'} />
                      </a>
                    ),
                    driver: (
                      <a href="https://driver.brenger.nl/nl/driver/login">
                        <Translate id={'authentication.new.driver'} />
                      </a>
                    ),
                  }}
                />
              </div>
            </Col>
          )}
          <Col xs={12} sm={12}>
            <Button
              fullWidth={true}
              loading={passwordNew.isPending}
              disabled={passwordNew.isPending || !form.isDirty || form.hasErrors}
              buttonStyle={'secondary'}
              type="submit"
            >
              <Translate id={'authentication.new.button'} />
            </Button>
          </Col>
        </Row>
      </form>
    </SectionWrapper>
  );
};
